var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content.content)?_c('div',{staticClass:"announcement"},[_c('div',{staticClass:"announcement__text",domProps:{"innerHTML":_vm._s(_vm.content.content)}}),(_vm.content.button)?_c('div',[_c('ButtonComponent',{attrs:{"tag":"a","label":_vm.content.button,"href":_vm.content.url}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }